const tmpl = require("riot-tmpl");
tmpl.brackets.set("{{ }}");
tmpl.tmpl.errorHandler = () => {};

export function evaluate(text, expressionData) {
  if (!text) return "";
  return tmpl.tmpl(text, expressionData);
}
